import React from 'react';

import { FaChevronRight } from 'react-icons/fa';
import shortid from 'shortid';

export default ({ staticContent: { list, title } }) => {
  return (
    <div className="container-fluid" style={{ background: '#EAEBF1' }}>
      <div className="container my-5 py-5">
        <div className="row">
          <div className="dedic-list result-list-single">
            <h2>{title}</h2>
            <div className="row mt-5">
              {list &&
                list.map(item => (
                  <div className="col-lg-4 col-md-6 dedic-item" key={item}>
                    <div className="item-list">
                      <div className="point">
                        <FaChevronRight />
                      </div>
                      <div
                        key={shortid.generate()}
                        className="body"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: item }}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
